module.exports = "/static/assets/58a85d2a2e017c3d519aed798e504ce6.png";